"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
require("./style.css");
function Spinner() {
    return (react_1.default.createElement("div", { className: 'spinnerContainer' },
        react_1.default.createElement("div", { className: 'loader' })));
}
exports.default = Spinner;
